const DEV_TOOLS = {
  TEXT_TO_IMAGE: '/text-to-image/get-started',
  TEXT_TO_LOGO: '/text-to-logo/get-started',
  UPSCALE_IMAGE: '/upscale-image/get-started',
  OBJECT_REMOVER: '/object-remover/get-started',
  OBJECT_REPLACER: '/object-replacer/get-started',
  GIF_MAKER: '/gif-maker/get-started',
  MEME_GENERATOR: '/meme-generator/get-started',
  STICKER_MAKER: '/sticker-maker/get-started',
  BLOG_WRITER: '/ai-blog-writer/get-started',
  EMAIL_GENERATOR: '/email-generator/get-started',
  TRANSCRIPT_GENERATOR: '/transcript',
  CHAT_WITH_DOCUMENTS: '/chat-with-docs/get-started',
  PODCAST_GENERATOR: '/ai-podcast-generator/get-started',
  TEXT_TO_SPEECH: '/text-to-speech/get-started',
  SOCIAL_MEDIA_GENERATOR: '/social-media/get-started',
  BRANDBOOK: '/brandbook/get-started',
  BOT_BUILDER: '/bot-builder/get-started',
  DASHBOARD: '/',
  SIGN_IN: '/auth/login',
};

const getDevelopmentToolRoute = (tool: keyof typeof DEV_TOOLS) => {
  return `${DEV_TOOLS[tool]}`;
};

export { getDevelopmentToolRoute as getDevToolRoute };
